// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAdjudicationRequest {
    static getAttributeTypeMap() {
        return ClaimAdjudicationRequest.attributeTypeMap;
    }
}
ClaimAdjudicationRequest.discriminator = undefined;
ClaimAdjudicationRequest.attributeTypeMap = [
    {
        "name": "outboundFileName",
        "baseName": "outboundFileName",
        "type": "string"
    },
    {
        "name": "claimId",
        "baseName": "claimId",
        "type": "string"
    },
    {
        "name": "masterClaimId",
        "baseName": "masterClaimId",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "tcGroupNumber",
        "baseName": "tcGroupNumber",
        "type": "string"
    },
    {
        "name": "receivedDate",
        "baseName": "receivedDate",
        "type": "string"
    },
    {
        "name": "processorCode",
        "baseName": "processorCode",
        "type": "string"
    },
    {
        "name": "claimTypeCode",
        "baseName": "claimTypeCode",
        "type": "ClaimTypeCode"
    },
    {
        "name": "dateOfService",
        "baseName": "dateOfService",
        "type": "string"
    },
    {
        "name": "patientDetails",
        "baseName": "patientDetails",
        "type": "ClaimAdjudicationPatientDetails"
    },
    {
        "name": "pharmacyInsurance",
        "baseName": "pharmacyInsurance",
        "type": "ClaimAdjudicationPharmacyInsurance"
    },
    {
        "name": "medicalInsurance",
        "baseName": "medicalInsurance",
        "type": "ClaimAdjudicationMedicalInsurance"
    },
    {
        "name": "providerDetails",
        "baseName": "providerDetails",
        "type": "ClaimAdjudicationProviderDetails"
    },
    {
        "name": "claimLineItems",
        "baseName": "claimLineItems",
        "type": "Array<ClaimAdjudicationClaimLineItem>"
    }
];
//# sourceMappingURL=claimAdjudicationRequest.js.map